import { HomeIcon } from '@heroicons/react/solid';
import {
  BellIcon,
  BookmarkIcon,
  ClipboardIcon,
  DotsCircleHorizontalIcon,
  DotsHorizontalIcon,
  HashtagIcon,
  InboxIcon,
  UserIcon,
} from '@heroicons/react/outline';
import { getAuth, onAuthStateChanged, signOut } from 'firebase/auth';
import { useEffect } from 'react';
import { db } from '../firebase';
import { doc, getDoc } from 'firebase/firestore';
import { useRecoilState } from 'recoil';
import { userState } from '../atom/userAtom';
import { useRouter } from 'next/router';
import Sideicon from './Sideicon';

export default function Sidebar() {
  const router = useRouter();
  const [currentUser, setCurrentUser] = useRecoilState(userState);
  console.log(currentUser);
  const auth = getAuth();
  useEffect(() => {
    onAuthStateChanged(auth, (user) => {
      if (user) {
        const fetchUser = async () => {
          const docRef = doc(db, 'users', auth.currentUser.providerData[0].uid);
          const docSnap = await getDoc(docRef);
          if (docSnap.exists()) {
            setCurrentUser(docSnap.data());
          }
        };
        fetchUser();
      }
    });
  }, []);

  function onSignOut() {
    signOut(auth);
    setCurrentUser(null);
  }

  return (
    <div className="hidden mb-4 sm:flex flex-col p-2 xl:items-start fixed h-full xl:ml-24 select-none ">
      {/* Menu */}

      <div className="flex items-center md:hidden sm:hidden xl:inline mb-[80px] mt-[40px] ">
        <h6 className="flex m-1 text-6xl text-sky-500/100 font-bold    xl:inline sm:hidden ">
          isocial
        </h6>

        <h1 className="text-sky-500 text-xl mt-3 -translate-y-5 capitalize hover:uppercase">
          By Amir Osama
        </h1>
      </div>

      <div className="xl:items-start mb-9">
        {/* Twitter Logo */}

        <Sideicon text="Home" Icon={HomeIcon} active />
        <Sideicon text="Explore" Icon={HashtagIcon} />
        {currentUser && (
          <>
            <Sideicon text="Notifications" Icon={BellIcon} />
            <Sideicon text="Messages" Icon={InboxIcon} />
            <Sideicon text="Bookmarks" Icon={BookmarkIcon} />
            <Sideicon text="Lists" Icon={ClipboardIcon} />
            <Sideicon text="Profile" Icon={UserIcon} />
            <Sideicon text="More" Icon={DotsCircleHorizontalIcon} />
          </>
        )}
      </div>

      {/* Button */}

      {currentUser ? (
        <>
          <button
            onClick={onSignOut}
            className="bg-blue-400 text-white rounded-full w-56 h-12 font-bold shadow-md hover:brightness-95 text-lg hidden xl:inline      transition ease-in-out delay-150  hover:-translate-y-1 hover:scale-110 hover:bg-blue-500 duration-300 ..."
          >
            signOut
          </button>

          {/* Mini-Profile */}

          <div className="hoverEffect text-gray-700 flex items-center justify-center xl:justify-start mt-auto">
            <img
              src={currentUser?.image}
              alt="user-img"
              className="h-10 w-10 rounded-full xl:mr-2"
            />
            <div className="leading-5 hidden xl:inline">
              <h4 className="font-bold text-gray-100">{currentUser?.name}</h4>
              <p className="text-gray-400">@{currentUser?.username}</p>
            </div>
            <DotsHorizontalIcon className="h-5 xl:ml-8 hidden xl:inline text-white " />
          </div>
        </>
      ) : (
        <button
          onClick={() => router.push('/auth/siginin')}
          className="bg-blue-500 text-white rounded-full w-36 h-12 font-bold shadow-md hover:brightness-95 text-lg hidden xl:inline    transition ease-in-out delay-150  hover:-translate-y-1 hover:scale-110 hover:bg-blue-500 duration-300 ..."
        >
          Sign in
        </button>
      )}
    </div>
  );
}
